export enum PaginationType {
  Paginated = 'paginated',
  InfiniteScroll = 'infinite',
  VirtualScroll = 'virtual'
}
